import React, { useState } from "react";

import Footer from "components/layout/Footer";

import QuickSearchResults from "features/quickSearch";
import Logo from "components/layout/Logo";
import MenuAppBar from "components/layout/MuiNavbar";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Box, Stack } from "@mui/material";
import bg1 from "assets/images/bg1.jpg";
import LabelBottomNavigation from "components/layout/MuiNavbar/BottomBar";
import { PrimarySearchBox } from "features/SourceSearch";
import { Helmet } from "react-helmet-async";

const Landing = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedCategory, setSelectedCategory] = useState(null);

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplate: `
          "header" auto
          "body" 1fr
          "footer" auto
          / 1fr
        `,
        minHeight: "100vh",
        backgroundImage: `url(${bg1})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Helmet>
        <title>Sooth - Start your search</title>
      </Helmet>
      <Stack
        direction="column"
        gap={2}
        alignItems="center"
        width="100%"
        height="40vh"
        px={5}
        pt="15vh"
        sx={{
          gridArea: "header",
        }}
      >
        <MenuAppBar
          isLandingPage={true}
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
          }}
        />
        <Logo isLandingPage={true} />
        <PrimarySearchBox isDarkBackground />
      </Stack>
      <Box
        sx={{
          gridArea: "body",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          py: "7.5rem",
          px: { xs: 3, md: 'unset' },
          backgroundColor: "background.paper",
          borderTopLeftRadius: "5rem",
          borderTopRightRadius: "5rem",
        }}
      >
        <QuickSearchResults />
      </Box>
      <Box sx={{ gridArea: "footer" }}>
        <LabelBottomNavigation />
        {!isMobile && <Footer isLandingPage={true} />}
      </Box>
    </Box>
  );
};

export default Landing;
